import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Cpu, BarChart2, Radio, Lock } from 'lucide-react';
const features = [{
  title: 'Nexus AI Engine',
  description: 'Our proprietary neural network analyzes millions of data points per second to adjust bids in real-time, ensuring you never overpay for a conversion.',
  icon: Cpu,
  color: 'text-emerald-400'
}, {
  title: 'Prism Analytics',
  description: 'Unified multi-channel attribution that cuts through the noise. See the true customer journey from first touch to final purchase across all devices.',
  icon: BarChart2,
  color: 'text-blue-400'
}, {
  title: 'Quantum Bidding',
  description: 'Predictive budget allocation that moves funds to high-performing ad sets automatically, maximizing ROAS without manual intervention.',
  icon: Radio,
  color: 'text-purple-400'
}, {
  title: 'Sentinel Monitoring',
  description: '24/7 automated performance alerts. Our system detects anomalies, ad fatigue, and budget pacing issues before they impact your bottom line.',
  icon: Lock,
  color: 'text-amber-400'
}];
export function Features() {
  return <section id="features" className="py-24 bg-slate-900" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center mb-16" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-54">
            Engineered for Performance
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-55">
            Butineurjeu isn't just a dashboard. It's an autonomous growth engine
            for your business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-56">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-57">
              <Card className="p-8 h-full bg-slate-800/50 border-slate-700 hover:bg-slate-800 transition-colors group" data-id="element-58">
                <div className="flex items-start gap-6" data-id="element-59">
                  <div className={`p-3 rounded-xl bg-slate-900 border border-slate-700 group-hover:border-slate-600 transition-colors`} data-id="element-60">
                    <feature.icon className={`w-8 h-8 ${feature.color}`} data-id="element-61" />
                  </div>
                  <div data-id="element-62">
                    <h3 className="text-xl font-bold text-white mb-3" data-id="element-63">
                      {feature.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed" data-id="element-64">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}